export default __webpack_public_path__ + "static/img-art-pandas-profiling-8-8e12b391900a26452853872b8ec8ff2d.png";